import publicApi from '../../api/public/publicApi'
class PublicClass {
  static getInstance() {
    if(!this.instance) {
      this.instance = new PublicClass()
    }
    return this.instance 
  }
  // 获取页面所有资源
  getAllResource() {
    return publicApi.getAllResource()
  }
  // 获取oss配置
  getOssConfig(data) {
    return publicApi.getOssConfig(data)
  }
}
export default PublicClass.getInstance()